import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { BlogAuthor } from 'src/app/blog-author.model';
import { BlogService } from 'src/app/blog.service';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-contributor-page',
	templateUrl: './contributor-page.component.html',
	styleUrls: ['./contributor-page.component.scss']
})
export class ContributorPageComponent implements OnInit {
	author: BlogAuthor;
	authorSlug: string;

	authorLoading = true;
	authorError = false;

	pageNumber = 0;

	nextPageURL: string = "";

	faChevronRight = faChevronRight;

	environment = environment;

	constructor(
		private metaSetter: MetaSetterService,
		private blogService: BlogService,
		private route: ActivatedRoute,
	) {
		this.authorSlug = this.route.snapshot.paramMap.get("author");

		if (this.route.snapshot.queryParamMap.has("page") && !isNaN(parseInt(this.route.snapshot.queryParamMap.get("page"), 10))) {
			this.pageNumber = parseInt(this.route.snapshot.queryParamMap.get("page"), 10) - 1;
		} else {
			this.pageNumber = 0;
		}
	}

	getAuthorInfo(): void {
		this.authorLoading = true;
		this.authorError = false;

		this.blogService.getAuthor(this.authorSlug)
			.subscribe(author => this.postAuthorFetch(author), () => {
				this.authorError = true;
			})
	}

	postAuthorFetch(author: BlogAuthor) {
		this.author = author;
		this.authorLoading = false;

		this.setMetadata();
	}

	setMetadata(): void {
		if (this.author) {

			this.nextPageURL = `${environment.canonicalDomain}/news/author/${this.authorSlug.toLowerCase()}?page=${this.pageNumber + 2}`

			this.metaSetter.setMeta({
				title: this.author.social_summary_title,
				description: this.author.social_summary_description,
				metaImageURL: environment.defaultMetaImage,
				canonicalURL: `${environment.canonicalDomain}/news/author/${this.authorSlug.toLowerCase()}${this.pageNumber === 0 ? `` : `?page=${this.pageNumber + 1}`}`,
				previousURL: this.pageNumber === 0 ? undefined : `${environment.canonicalDomain}/news/author/${this.authorSlug.toLowerCase()}${this.pageNumber === 1 ? `` : `?page=${this.pageNumber}`}`,
				// nextURL: `${environment.canonicalDomain}/news/author/${this.authorSlug.toLowerCase()}?page=${this.pageNumber + 2}`
			});
		}
	}

	ngOnInit(): void {
		this.getAuthorInfo();

		

		this.route.params.subscribe((data) => {
			if (data.author && this.authorSlug !== data.author) {
				this.authorSlug = data.author;

				this.getAuthorInfo();

			}
		});

		this.route.queryParams.subscribe((data) => {
			if (data.page && !isNaN(parseInt(data.page, 10)) && parseInt(data.page, 10) - 1 !== this.pageNumber) {
				this.pageNumber = parseInt(data.page, 10) - 1;
				this.setMetadata();
			}

			if (!data.page || isNaN(parseInt(data.page, 10))) {
				this.pageNumber = 0;
				this.setMetadata();
			}
		})
	}

}
